import React from "react";

import { useSelector } from "react-redux";

import { DeliveryCard } from "components/Pdfs";

import { useSaleRoundRouteParams } from "hooks";
import { getPensByAgentId } from "lib/pdf";

import {
  getAuctionPensWithSaleLotsBySaleAndRound,
  currentSaleSelector,
  getOrganizationName,
  currentRoundSelector,
} from "selectors";

const DeliveryCardContainer = () => {
  const { agentId, saleRoundProps } = useSaleRoundRouteParams();

  const allAuctionPens = useSelector(state =>
    getAuctionPensWithSaleLotsBySaleAndRound(state, saleRoundProps),
  );
  const auctionPens = agentId
    ? getPensByAgentId(allAuctionPens, agentId)
    : allAuctionPens;

  const sale = useSelector(currentSaleSelector);
  const agencyName = useSelector(getOrganizationName);
  const round = useSelector(state =>
    currentRoundSelector(state, saleRoundProps),
  );

  return (
    <DeliveryCard
      auctionPens={auctionPens}
      sale={sale}
      agencyName={agencyName}
      round={round}
    />
  );
};

export default DeliveryCardContainer;
